export default "__VITE_ASSET__D_K61612__"